import * as React from 'react';
import { cn } from '@/lib/utils';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(({ className, ...p }, ref) => (
  <input
    ref={ref}
    className={cn(
      'flex h-11 w-full rounded-md border border-border bg-surface px-3 text-[15px] text-ink shadow-sm placeholder:text-muted-2 focus-visible:outline-2 focus-visible:outline-primary disabled:opacity-50',
      className,
    )}
    {...p}
  />
));
Input.displayName = 'Input';

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...p }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-24 w-full rounded-md border border-border bg-surface px-3 py-2.5 text-[15px] text-ink shadow-sm placeholder:text-muted-2 focus-visible:outline-2 focus-visible:outline-primary',
        className,
      )}
      {...p}
    />
  ),
);
Textarea.displayName = 'Textarea';

export function Label({ className, ...p }: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn('text-[13px] font-medium text-ink-2', className)} {...p} />;
}
